export default __webpack_public_path__ + "static/media/contactIcon2.4c5cb804.png";